import { Card, Col, Container, Row } from 'react-bootstrap';
import { FaEnvelope, FaFacebook, FaInstagram, FaMapMarkerAlt, FaPhone, FaWhatsapp } from 'react-icons/fa';

const Contact = () => {
  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col lg={10}>
          <div className="text-center mb-5">
            <h2 className="display-4 fw-bold text-primary mb-3">संपर्क करें</h2>
            <p className="lead text-muted">हमसे जुड़ें और अपने सवालों के जवाब पाएं</p>
          </div>

          <Row className="g-4">
            {/* Contact Information Cards */}
            <Col md={6} lg={4}>
              <Card className="h-100 shadow-sm border-0 contact-card">
                <Card.Body className="text-center p-4">
                  <div className="contact-icon mb-3">
                    <FaPhone className="text-primary" size={40} />
                  </div>
                  <h5 className="fw-bold mb-3">फोन नंबर</h5>
                  <a href="tel:+919425006497" className="text-decoration-none">
                    <p className="mb-0 fs-5 text-dark">+91 94250 06497</p>
                  </a>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6} lg={4}>
              <Card className="h-100 shadow-sm border-0 contact-card">
                <Card.Body className="text-center p-4">
                  <div className="contact-icon mb-3">
                    <FaEnvelope className="text-primary" size={40} />
                  </div>
                  <h5 className="fw-bold mb-3">ईमेल</h5>
                  <a href="mailto:jainsamagraportal@gmail.com" className="text-decoration-none">
                    <p className="mb-0 fs-6 text-dark">jainsamagraportl@gmail.com</p>
                  </a>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6} lg={4}>
              <Card className="h-100 shadow-sm border-0 contact-card">
                <Card.Body className="text-center p-4">
                  <div className="contact-icon mb-3">
                    <FaMapMarkerAlt className="text-primary" size={40} />
                  </div>
                  <h5 className="fw-bold mb-3">स्थान</h5>
                  <p className="mb-0 text-muted">दमोह, मध्य प्रदेश</p>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Social Media Section */}
          <div className="text-center mt-5">
            <h4 className="fw-bold mb-4">हमसे जुड़ें</h4>
            <Row className="justify-content-center g-3">
              <Col xs={6} sm={4} md={3}>
                <a 
                  href="https://api.whatsapp.com/send?phone=919425006497" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-decoration-none"
                >
                  <Card className="social-card border-0 shadow-sm">
                    <Card.Body className="text-center p-3">
                      <FaWhatsapp className="text-success mb-2" size={30} />
                      <p className="mb-0 small fw-bold">WhatsApp</p>
                    </Card.Body>
                  </Card>
                </a>
              </Col>

              <Col xs={6} sm={4} md={3}>
                <a 
                  href="https://www.instagram.com/jainsamagraportal" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-decoration-none"
                >
                  <Card className="social-card border-0 shadow-sm">
                    <Card.Body className="text-center p-3">
                      <FaInstagram className="text-danger mb-2" size={30} />
                      <p className="mb-0 small fw-bold">Instagram</p>
                    </Card.Body>
                  </Card>
                </a>
              </Col>

              <Col xs={6} sm={4} md={3}>
                <a 
                  href="https://www.facebook.com/profile.php?id=61587019646175" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-decoration-none"
                >
                  <Card className="social-card border-0 shadow-sm">
                    <Card.Body className="text-center p-3">
                      <FaFacebook className="text-primary mb-2" size={30} />
                      <p className="mb-0 small fw-bold">Facebook</p>
                    </Card.Body>
                  </Card>
                </a>
              </Col>
            </Row>
          </div>

          {/* Additional Info Section */}
          <div className="mt-5 p-4 bg-light rounded-4">
            <div className="text-center">
              <h4 className="fw-bold mb-3 text-primary">हमारे बारे में</h4>
              <p className="lead text-muted mb-4">
                जैन समग्र पोर्टल - जैन समुदाय के लिए एक डिजिटल प्लेटफॉर्म
              </p>
              <div className="d-flex justify-content-center gap-4 flex-wrap">
                <div className="text-center">
                  <div className="bg-primary bg-opacity-10 rounded-circle p-3 d-inline-block mb-2">
                    <span className="fw-bold text-primary fs-4">24/7</span>
                  </div>
                  <p className="small mb-0">सेवा उपलब्ध</p>
                </div>
                <div className="text-center">
                  <div className="bg-success bg-opacity-10 rounded-circle p-3 d-inline-block mb-2">
                    <span className="fw-bold text-success fs-4">100%</span>
                  </div>
                  <p className="small mb-0">सुरक्षित</p>
                </div>
                <div className="text-center">
                  <div className="bg-info bg-opacity-10 rounded-circle p-3 d-inline-block mb-2">
                    <span className="fw-bold text-info fs-4">∞</span>
                  </div>
                  <p className="small mb-0">निःशुल्क</p>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <style jsx>{`
        .contact-card {
          transition: all 0.3s ease;
          background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);
        }
        .contact-card:hover {
          transform: translateY(-8px) scale(1.02);
          box-shadow: 0 15px 35px rgba(0,0,0,0.15) !important;
        }
        .social-card {
          transition: all 0.3s ease;
          cursor: pointer;
          background: linear-gradient(135deg, #fff 0%, #f8f9fa 100%);
        }
        .social-card:hover {
          transform: translateY(-5px) scale(1.05);
          box-shadow: 0 12px 25px rgba(0,0,0,0.15) !important;
        }
        .contact-icon {
          display: inline-block;
          padding: 20px;
          background: linear-gradient(135deg, rgba(13, 110, 253, 0.1) 0%, rgba(13, 110, 253, 0.05) 100%);
          border-radius: 50%;
          box-shadow: 0 4px 15px rgba(13, 110, 253, 0.2);
        }
        .display-4 {
          background: linear-gradient(135deg, #0d6efd 0%, #6610f2 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
      `}</style>
    </Container>
  );
};

export default Contact;